import { Form, Select } from "antd";
import { ReactElement, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";

import "./edit-communication.scss";
import { PhoneInput } from "react-international-phone";

import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import ReactCountryFlag from "react-country-flag";
import { LOADING } from "src/store/actions";
import instance from "src/store/axios";
import Label from "src/components/label/label.component";
import CustomInput from "src/components/custom-input/custom-input.component";

const { Option } = Select;

const EditCommunication: React.FC<{
  onSuccess: () => void;
  accountDetails: any;
}> = ({ onSuccess, accountDetails }): ReactElement => {
  const { accountId, activeKyc } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isApproveCase = queryParams.get("approve");
  const [form] = Form.useForm();
  const [countriesData, setCountriesData] = useState([]);
  const residentialCountryId = Form.useWatch("residentialCountryId", form);
  const isSaudiResidential = residentialCountryId === 154;
  const workCountryId = Form.useWatch("workCountryId", form);
  const isSaudiWork = workCountryId === 154;
  const guardianResidentCountryId = Form.useWatch("guardianResidentCountryId", form);
  const isSaudiGuardianResidential = guardianResidentCountryId === 154;
  const [citiesList, setCitiesList] = useState<any[]>([]);

  useEffect(() => {
    getCountriesData();
  }, []);

  useEffect(() => {
    if (isSaudiResidential || isSaudiWork) {
      getCitiesData(residentialCountryId);
    } else {
      setCitiesList([]);
    }
  }, [residentialCountryId]);

  const getCountriesData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION
        }/option/countries?partial=${1}`
      );
      setCountriesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/home/new-kyc/${accountDetails?.id}/${accountDetails?.pendingKycId}`
      );
    }
  };

  const getCitiesData = async (stateId: number): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/saudi-cities`
      );
      setCitiesList(response.data.data || response.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
    }
  };

  const onSubmit = async (values: any): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    values.kycId = accountDetails.accountInfo[0]?.id;
    values.residentialFloor = "";
    values.branch = "SA";
    values.residentialBlock = "";
    values.residentialAddressDetails = "";

    if (!values.workCountryId) {
      delete values.workCountryId;
      delete values.workCity;
      delete values.workBuilding;
      delete values.workStreet;
      delete values.workAvenue;
      delete values.workBlock;
      delete values.workPoBox;
      delete values.workPostalCode;
      delete values.workAddressDetails;
    }



    // for (const key in values) {
    //   if (values[key] === null) {
    //     values[key] = "";
    //   }
    // }

    try {
      await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/communication/update`,
        values
      );
      onSuccess();
      toast.success("Communication & Address updated successfully");
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/home/new-kyc/${accountDetails?.id}/${accountDetails?.pendingKycId}`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  return (
    <div className="edit-communication flex flex-col mt-5">
      <h2 className=" font-semibold text-xl mb-8">Communication & Address</h2>
      {accountDetails?.id && (
        <Form
          className="add-edit-form flex flex-col gap-5"
          onFinish={onSubmit}
          initialValues={{
            mobileNumber: accountDetails?.accountInfo[0]?.mobileNumber,
            workNumber: accountDetails?.accountInfo[0]?.workNumber,
            homeNumber: accountDetails?.accountInfo[0]?.homeNumber,
            residentialBuilding:
              accountDetails?.accountInfo[0]?.residentialBuilding,
            residentialStreet:
              accountDetails?.accountInfo[0]?.residentialStreet,
            residentialAvenue:
              accountDetails?.accountInfo[0]?.residentialAvenue,
            residentialBlock: accountDetails?.accountInfo[0]?.residentialBlock,
            residentialCountryId:
              accountDetails?.accountInfo[0]?.residentialCountryId,
            residentialCity: accountDetails?.accountInfo[0]?.residentialCity,
            residentialPoBox: accountDetails?.accountInfo[0]?.residentialPoBox,
            residentialZipCode:
              accountDetails?.accountInfo[0]?.residentialZipCode,
            residentialAddressDetails:
              accountDetails?.accountInfo[0]?.residentialAddressDetails,
            workBuilding: accountDetails?.accountInfo[0]?.workBuilding,
            workStreet: accountDetails?.accountInfo[0]?.workStreet,
            workAvenue: accountDetails?.accountInfo[0]?.workAvenue,
            workBlock: accountDetails?.accountInfo[0]?.workBlock,
            workCity: accountDetails?.accountInfo[0]?.workCity,
            workCountryId: accountDetails?.accountInfo[0]?.workCountryId,
            workPoBox: accountDetails?.accountInfo[0]?.workPoBox,
            workPostalCode: accountDetails?.accountInfo[0]?.workPostalCode,
            workAddressDetails:
              accountDetails?.accountInfo[0]?.workAddressDetails,
            residentAddressSecondaryNumber:
              accountDetails?.accountInfo[0]?.residentAddressSecondaryNumber,
            residentShortAddress:
              accountDetails?.accountInfo[0]?.residentShortAddress,
            workAddressSecondaryNumber:
              accountDetails?.accountInfo[0]?.workAddressSecondaryNumber,
            workShortAddress: accountDetails?.accountInfo[0]?.workShortAddress,
            workEmail: accountDetails?.accountInfo[0]?.workEmail,
            workWebsite: accountDetails?.accountInfo[0]?.workWebsite,
            workFax: accountDetails?.accountInfo[0]?.workFax,
            otherAddressCountryId: accountDetails?.accountInfo[0]?.otherAddressCountryId,
            otherAddressCity: accountDetails?.accountInfo[0]?.otherAddressCity,
            otherAddressPoBox: accountDetails?.accountInfo[0]?.otherAddressPoBox,
            otherAddressZipCode: accountDetails?.accountInfo[0]?.otherAddressZipCode,
            otherAddressDistrict: accountDetails?.accountInfo[0]?.otherAddressDistrict,
            otherAddressStreet: accountDetails?.accountInfo[0]?.otherAddressStreet,
            guardianResidentCountryId: accountDetails?.accountInfo[0].guardianResidentCountry?.id,
            guardianCity: accountDetails?.accountInfo[0].guardianCity,
            guardianPoBox: accountDetails?.accountInfo[0].guardianPoBox,
            guardianZipCode: accountDetails?.accountInfo[0].guardianZipCode,
            guardianDistrict: accountDetails?.accountInfo[0].guardianDistrict,
            guardianStreet: accountDetails?.accountInfo[0].guardianStreet,
            guardianAddressSecondaryNumber: accountDetails?.accountInfo[0].guardianAddressSecondaryNumber,
            guardianBuilding: accountDetails?.accountInfo[0].guardianBuilding,
            guardianShortAddress: accountDetails?.accountInfo[0].guardianShortAddress,
          }}
          form={form}
        >
          <div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">Communication Details</h3>
          </div>
          <div className="fields flex justify-space-between wrap">
            <div className="field flex column">
              <Label text="Mobile" required />
              <Form.Item
                name="mobileNumber"
                rules={[
                  {
                    required: true,
                    message: "Please input your mobile number!",
                  },
                  ...(isSaudiResidential
                    ? [
                      {
                        validator: (_: any, value: string) => {
                          if (!value) return Promise.resolve();
                          const digits = value.replace(/\D/g, "");
                          // +966 = country code (3 digits) + 9 digits phone
                          if (digits.startsWith("966") && digits.length !== 12) {
                            return Promise.reject(
                              "Phone number must be 9 digits after country code"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]
                    : []),
                ]}
              >
                <div className="phone-input">
                  <PhoneInput
                    placeholder="Enter mobile number"
                    value={accountDetails?.accountInfo[0]?.mobileNumber || ""}
                    defaultCountry="sa"
                  // onChange={() => setValue("")}
                  />
                  <span className="sub-text">
                    Phone number format: countrycode-phone (Example:
                    +966-000000000)
                  </span>
                </div>
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Other Phone / Mobile No." />
              <Form.Item
                name="otherPhoneNumber"
                rules={
                  isSaudiResidential
                    ? [
                      {
                        validator: (_: any, value: string) => {
                          if (!value) return Promise.resolve();
                          const digits = value.replace(/\D/g, "");
                          if (digits.startsWith("966") && digits.length !== 12) {
                            return Promise.reject(
                              "Phone number must be 9 digits after country code"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]
                    : []
                }
              >
                <div className="phone-input">
                  <PhoneInput
                    placeholder="Enter Other Phone / Mobile No."
                    value={accountDetails?.accountInfo[0]?.homeNumber || ""}
                    defaultCountry="sa"
                  // onChange={() => setValue("")}
                  />
                  <span className="sub-text">
                    Phone number format: countrycode-phone (Example:
                    +966-000000000)
                  </span>
                </div>
              </Form.Item>
            </div>
          </div>

          <div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">
              Residential address details
            </h3>
          </div>

          <div className="fields flex justify-space-between wrap">
            <div className="field flex column">
              <Label text="Home Tel." />
              <Form.Item
                name="homeNumber"

              >
                <div className="phone-input">
                  <PhoneInput
                    placeholder="Enter Home Tel."
                    value={accountDetails?.accountInfo[0]?.homeNumber || ""}
                    defaultCountry="sa"
                  // onChange={() => setValue("")}
                  />
                  <span className="sub-text">
                    Phone number format: countrycode-phone (Example:
                    +966-000000000)
                  </span>
                </div>
              </Form.Item>
            </div>
          </div>

          <div className="fields flex justify-space-between wrap">
            <div className="field flex flex-col">
              <Label text="Country" required />
              <Form.Item
                name="residentialCountryId"
                rules={[
                  {
                    required: true,
                    message: "Please select the Country!",
                  },
                ]}
                validateTrigger={["onChange", "onBlur"]}
              >
                <Select
                  placeholder="Select Country"
                  allowClear
                  showSearch
                  filterOption={(input, option: any) => {
                    return (option?.key.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    );
                  }}
                >
                  {countriesData.map((country: any) => (
                    <Option value={country.id} key={country.nameEn}>
                      <div className="flex align-center" style={{ gap: "5px" }}>
                        <ReactCountryFlag
                          style={{
                            fontSize: "24px",
                            marginInlineEnd: "8px",
                          }}
                          countryCode={country?.countryCode}
                          svg
                        />
                        <span>{country.nameEn}</span>
                      </div>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="City" required />
              <Form.Item
                name="residentialCity"
                rules={[
                  {
                    required: true,
                    message: "Please select the city!",
                  },
                ]}
              >
                {isSaudiResidential ? (
                  <Select
                    placeholder="Select city"
                    allowClear
                    showSearch
                    filterOption={(input, option: any) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                  >
                    {citiesList.map((city: any) => (
                      <Option value={city.nameEn || city.name} key={city.id} label={city.nameEn || city.name}>
                        {city.nameEn || city.name} - {city?.nameAr}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <CustomInput placeholder="Enter city" />
                )}
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="P.O.Box" />
              <Form.Item
                name="residentialPoBox"
              >
                <CustomInput placeholder="Enter input P.O.Boxe" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="ZIP Code" required />
              <Form.Item
                name="residentialZipCode"
                rules={[
                  {
                    required: true,
                    message: "Please enter ZIP Code!",
                  },
                ]}
              >
                <CustomInput placeholder="Enter input Postal Code" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="District" required />
              <Form.Item
                name="residentialAvenue"
                rules={[
                  {
                    required: true,
                    message: "Please enter District!",
                  },
                ]}
              >
                <CustomInput placeholder="Enter District" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Street name" required />
              <Form.Item
                name="residentialStreet"
                rules={[
                  {
                    required: true,
                    message: "Please enter Street name!",
                  },
                ]}
              >
                <CustomInput placeholder="Enter street name" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Secondary No." required />
              <Form.Item
                name="residentAddressSecondaryNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter Secondary No.!",
                  },
                ]}
              >
                <CustomInput placeholder="Enter Secondary No." />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Building No." required />
              <Form.Item
                name="residentialBuilding"
                rules={[
                  {
                    required: true,
                    message: "Please enter Building No.!",
                  },
                ]}
              >
                <CustomInput placeholder="Enter Building No." />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Short Address" required />
              <Form.Item
                name="residentShortAddress"
                rules={[
                  {
                    required: true,
                    message: "Please enter Short Address!",
                  },
                  {
                    pattern: /^[A-Za-z]{4}\d{4}$/,
                    message: "Must be 4 characters followed by 4 digits",
                  },
                ]}
              >
                <CustomInput placeholder="Enter Short Address" maxLength={8} />
              </Form.Item>
            </div>

          </div>

          <div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">Work address details</h3>
          </div>
          <div className="flex flex-col">
            <div className="fields flex justify-space-between wrap">
              <div className="field flex column">
                <Label text="Work Tel." />
                <Form.Item name="workNumber">
                  <div className="phone-input">
                    <PhoneInput
                      placeholder="Enter Work Tel."
                      value={accountDetails?.accountInfo[0]?.workNumber || ""}
                      defaultCountry="sa"
                    // onChange={() => setValue("")}
                    />
                    <span className="sub-text">
                      Phone number format: countrycode-phone (Example:
                      +966-00000000)
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className="field flex column">
                <Label text="Fax" />
                <Form.Item name="workFax">
                  <CustomInput placeholder="Enter input Fax" />
                </Form.Item>
              </div>

            </div>
            <div className="fields flex justify-space-between wrap">


              <div className="field flex column">
                <Label text="Country" />
                <Form.Item
                  name="workCountryId"
                >
                  <Select
                    placeholder="Select Country"
                    showSearch
                    filterOption={(input, option: any) => {
                      return (option?.key.toLowerCase() ?? "").includes(
                        input.toLowerCase()
                      );
                    }}
                  >
                    {countriesData.map((country: any) => (
                      <Option value={country.id} key={country.nameEn}>
                        <div
                          className="flex align-center"
                          style={{ gap: "5px" }}
                        >
                          <ReactCountryFlag
                            style={{
                              fontSize: "24px",
                              marginInlineEnd: "8px",
                            }}
                            countryCode={country?.countryCode}
                            svg
                          />
                          <span>{country.nameEn}</span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="City" />
                <Form.Item
                  name="workCity"
                >
                  {isSaudiWork ? (
                    <Select
                      placeholder="Select city"
                      allowClear
                      showSearch
                      filterOption={(input, option: any) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                    >
                      {citiesList.map((city: any) => (
                        <Option value={city.nameEn || city.name} key={city.id} label={city.nameEn || city.name}>
                          {city.nameEn || city.name} - {city?.nameAr}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    <CustomInput placeholder="Enter city" />
                  )}
                </Form.Item>
              </div>

              <div className="field flex column">
                <Label text="P.O.Box" />
                <Form.Item name="workPoBox">
                  <CustomInput placeholder="Enter input P.O.Boxe" />
                </Form.Item>
              </div>

              <div className="field flex column">
                <Label text="ZIP Code" />
                <Form.Item name="workPostalCode">
                  <CustomInput placeholder="Enter input ZIP Code" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="District" />
                <Form.Item name="workAvenue">
                  <CustomInput placeholder="Enter District" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Street name" />
                <Form.Item
                  name="workStreet"
                >
                  <CustomInput placeholder="Enter street name" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Secondary No." />
                <Form.Item name="workAddressSecondaryNumber">
                  <CustomInput placeholder="Enter Secondary No." />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Building No." />
                <Form.Item
                  name="workBuilding"

                >
                  <CustomInput placeholder="Enter Building No." />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Short Address" />
                <Form.Item
                  name="workShortAddress"
                  rules={[
                    {
                      pattern: /^[A-Za-z]{4}\d{4}$/,
                      message: "Must be 4 characters followed by 4 digits",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Short Address" maxLength={8} />
                </Form.Item>
              </div>



              <div className="field flex column">
                <Label text="Work email" />
                <Form.Item
                  name="workEmail"
                  rules={[
                    {
                      type: "email",
                      message: "Please enter a valid email address",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter input Work email" />
                </Form.Item>
              </div>

              <div className="field flex column">
                <Label text="Website" />
                <Form.Item
                  name="workWebsite"
                  rules={[
                    {
                      type: "url",
                      message: "Please enter a valid URL",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter input Website" />
                </Form.Item>
              </div>

            </div>


          </div>

          <div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">
              Mailing Address Outside Kingdom (For Non-Saudis)
            </h3>
          </div>

          <div className="fields flex justify-space-between wrap">
            <div className="field flex flex-col">
              <Label text="Country" />
              <Form.Item
                name="otherAddressCountryId"

              >
                <Select
                  placeholder="Select Country"
                  allowClear
                  showSearch
                  filterOption={(input, option: any) => {
                    return (option?.key.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    );
                  }}
                >
                  {countriesData?.filter((country: any) => country.id !== 154)?.map((country: any) => (
                    <Option value={country.id} key={country.nameEn}>
                      <div className="flex align-center" style={{ gap: "5px" }}>
                        <ReactCountryFlag
                          style={{
                            fontSize: "24px",
                            marginInlineEnd: "8px",
                          }}
                          countryCode={country?.countryCode}
                          svg
                        />
                        <span>{country.nameEn}</span>
                      </div>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="City" />
              <Form.Item
                name="otherAddressCity"

              >
                <CustomInput placeholder="Enter city" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="P.O.Box" />
              <Form.Item name="otherAddressPoBox">
                <CustomInput placeholder="Enter input P.O.Boxe" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="ZIP Code" />
              <Form.Item name="otherAddressZipCode">
                <CustomInput placeholder="Enter input Postal Code" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="District" />
              <Form.Item name="otherAddressDistrict">
                <CustomInput placeholder="Enter District" />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Street name" />
              <Form.Item
                name="otherAddressStreet"

              >
                <CustomInput placeholder="Enter street name" />
              </Form.Item>
            </div>
          </div>

          {accountDetails?.clientSubType?.description === "Minor" && (<><div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">
              Guardian address details
            </h3>
          </div>

            <div className="fields flex justify-space-between wrap">
              <div className="field flex flex-col">
                <Label text="Country" required />
                <Form.Item
                  name="guardianResidentCountryId"
                  validateTrigger={["onChange", "onBlur"]}
                  rules={[
                    {
                      required: true,
                      message: "Please select Country!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Country"
                    allowClear
                    showSearch
                    filterOption={(input, option: any) => {
                      return (option?.key.toLowerCase() ?? "").includes(
                        input.toLowerCase()
                      );
                    }}
                  >
                    {countriesData.map((country: any) => (
                      <Option value={country.id} key={country.nameEn}>
                        <div className="flex align-center" style={{ gap: "5px" }}>
                          <ReactCountryFlag
                            style={{
                              fontSize: "24px",
                              marginInlineEnd: "8px",
                            }}
                            countryCode={country?.countryCode}
                            svg
                          />
                          <span>{country.nameEn}</span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="City" required />
                <Form.Item
                  name="guardianCity"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the city!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter city" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="P.O.Box" />
                <Form.Item
                  name="guardianPoBox"

                >
                  <CustomInput placeholder="Enter input P.O.Boxe" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="ZIP Code" required />
                <Form.Item
                  name="guardianZipCode"
                  rules={[
                    {
                      required: true,
                      message: "Please enter ZIP Code!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter input Postal Code" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="District" required />
                <Form.Item
                  name="guardianDistrict"
                  rules={[
                    {
                      required: true,
                      message: "Please enter District!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter District" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Street name" required />
                <Form.Item
                  name="guardianStreet"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Street name!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter street name" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Secondary No." required />
                <Form.Item
                  name="guardianAddressSecondaryNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Secondary No.!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Secondary No." />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Building No." required />
                <Form.Item
                  name="guardianBuilding"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Building No.!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Building No." />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Short Address" required />
                <Form.Item
                  name="guardianShortAddress"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Short Address!",
                    },
                    {
                      pattern: /^[A-Za-z]{4}\d{4}$/,
                      message: "Must be 4 characters followed by 4 digits",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Short Address" maxLength={8} />
                </Form.Item>
              </div>
            </div>
          </>)}

          <div className="flex w-full flex-wrap items-center justify-end mt-7 pt-5">
            <div className="flex justify-between items-center w-[70%] md:w-[48%]">
              <button
                onClick={() =>
                  navigate(
                    `/home/customers-list`
                  )
                }
                className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
              >
                Cancel
              </button>
              <button className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white">
                Save and continue
              </button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

export default EditCommunication;
